import { RevisionRow } from 'components/tables/data/revision/types';

export type BulkRevisionKindGroup = 'revision' | 'other' | 'mixed' | 'empty';

/**
 * Resolves selected revisions into kind groups:
 * - `revision`: all are kind "revision"
 * - `other`: none are kind "revision" (non-revision kinds can be mixed)
 * - `mixed`: both "revision" and non-revision kinds are present
 * - `empty`: no revisions selected
 */
export function getBulkRevisionKindGroup(revisions: Pick<RevisionRow, 'kind'>[]): BulkRevisionKindGroup {
  if (revisions.length === 0) {
    return 'empty';
  }

  const hasRevisionKind = revisions.some(({ kind }) => kind === 'revision');
  const hasOtherKind = revisions.some(({ kind }) => kind !== 'revision');

  if (hasRevisionKind && hasOtherKind) {
    return 'mixed';
  }

  return hasRevisionKind ? 'revision' : 'other';
}
